import { getLocalTimezone, getSessionUUID, getUUID } from '@/lib';
import Cookies from 'js-cookie';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// getBreadcrumbs,
// getPageURL,
// showProductEditorNavigation,
// showProductEditorPreview,
// showPreview,
// setShowNavigation,
// setShowProductEditorPreview,

export interface Breadcrumb {
    title: string;
    to: string;
    query?: Record<string, string>;
    params?: Record<string, string>;
    active?: boolean;
    id: string;
}

export interface GlobalStore {
    breadcrumbs: Breadcrumb[];
    pageURL: string;
    showProductEditorNavigation: boolean;
    showProductEditorPreview: boolean;
    showPreview: boolean;
    ipAddress: string;
    deviceToken: string;
    UUID: string;
    sessionUUID: string;
    darkMode: boolean;
    sessionTimezone: string;
    loadingRegistry: Set<string>;
    // setters
    setBreadcrumbs: (breadcrumbs: Breadcrumb[]) => void;
    setShowNavigation: (show: boolean) => void;
    setShowProductEditorPreview: (show: boolean) => void;
    setIpAddress: (ipAddress: string) => void;
    setDeviceToken: (deviceToken: string) => void;
    setDarkMode: (darkMode: boolean) => void;
    setSessionTimezone: (timezone: string) => void;
    registerLoading: (key: string) => void;
    unregisterLoading: (key: string) => void;
    clearAllLoading: () => void;
    // getters
    getDeviceToken: () => string;
    isPageLoading: () => boolean;
}

export const useGlobalStore = create<GlobalStore>()(
    persist(
        (set, get) => ({
            breadcrumbs: [],
            pageURL: '',
            showProductEditorNavigation: false,
            showProductEditorPreview: false,
            showPreview: false,
            ipAddress: '',
            deviceToken: '',
            UUID: getUUID(),
            sessionUUID: getSessionUUID(),
            darkMode: Cookies.get('darkMode') === 'true',
            sessionTimezone: Cookies.get('sessionTimezone') || getLocalTimezone(),

            showNavigation: false,
            loadingRegistry: new Set<string>(),
            setBreadcrumbs: (breadcrumbs: Breadcrumb[]) => set({ breadcrumbs }),
            setShowNavigation: (show: boolean) => set({ showProductEditorNavigation: show }),
            setShowProductEditorPreview: (show: boolean) => set({ showProductEditorPreview: show }),
            setIpAddress: (ipAddress: string) => set({ ipAddress }),
            setDeviceToken: (deviceToken: string) => set({ deviceToken }),
            setDarkMode: (darkMode: boolean) => {
                set({ darkMode });
                Cookies.set('darkMode', darkMode.toString());
            },
            setSessionTimezone: (timezone: string) => {
                set({ sessionTimezone: timezone });
                Cookies.set('sessionTimezone', timezone);
            },
            registerLoading: (key: string) => {
                const newRegistry = new Set(get().loadingRegistry);
                newRegistry.add(key);
                set({ loadingRegistry: newRegistry });
            },
            unregisterLoading: (key: string) => {
                const newRegistry = new Set(get().loadingRegistry);
                newRegistry.delete(key);
                set({ loadingRegistry: newRegistry });
            },
            clearAllLoading: () => {
                set({ loadingRegistry: new Set<string>() });
            },
            setShowPreview: (show: boolean) => set({ showPreview: show }),
            isPageLoading: () => {
                return get().loadingRegistry.size > 0;
            },

            getDeviceToken: () => {
                if (get().deviceToken === '' && Cookies.get('x-session-id') !== '') {
                    set({ deviceToken: Cookies.get('x-session-id') });
                }

                const in1Year = 1 * 365; // js-cookies uses days as base unit
                Cookies.set('x-session-id', get().deviceToken, { expires: in1Year });
                Cookies.set('x-session-id', get().deviceToken, { domain: 'stanwith.me', expires: in1Year });
                Cookies.set('x-session-id', get().deviceToken, { domain: 'stan.store', expires: in1Year });

                return get().deviceToken;
            },
        }),
        {
            name: 'global-storage',
            partialize: state => ({
                breadcrumbs: state.breadcrumbs,
            }),
        }
    )
);
